import { gql } from '@apollo/client/core'
import { useQuery } from '@vue/apollo-composable'
import type { Ref } from 'vue'
import { computed } from 'vue'
import type { MyTaskTemplatesQuery } from '@/src/graphql/operations'
import { MyTaskTemplatesDocument } from '@/src/graphql/operations'

// NOTE: colorHueは予定登録パレットのチップの色に使う(TaskTemplateSelectでは使わない)
gql`
  query myTaskTemplates {
    currentUser {
      id
      activeTaskTemplates {
        id
        colorHue
        ...taskTemplateForTaskTemplateSelect
      }
    }
  }
`

export type MyTaskTemplate = MyTaskTemplatesQuery['currentUser']['activeTaskTemplates'][number]

type UseMyTaskTemplatesReturn = {
  taskTemplates: Ref<readonly MyTaskTemplate[]>
  loading: Ref<boolean>
}

export const useMyTaskTemplates = (): UseMyTaskTemplatesReturn => {
  const { result, loading } = useQuery(MyTaskTemplatesDocument)

  const taskTemplates = computed<readonly MyTaskTemplate[]>(() => result.value?.currentUser.activeTaskTemplates ?? [])

  return { taskTemplates, loading }
}
